/**
 * aecdxc-add-all-to-cart.js
 * Horizon 3.4.0 compatible
 *
 * - Add All to Cart: adds all products on the current page, skipping duplicates
 * - Clear Cart: empties the cart after a confirmation prompt
 * - Both dispatch Horizon's cart:update event so the cart icon updates instantly
 */

(function () {
  var CAP = 100;

  var addBtn = document.getElementById('aecdxc-add-all-btn');
  var clearBtn = document.getElementById('aecdxc-clear-cart-btn');
  var statusEl = document.getElementById('aecdxc-add-all-status');
  if (!addBtn || !statusEl) return;

  /* ====================================
     HORIZON CART UI REFRESH
     ==================================== */

  function refreshHorizonCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Horizon 3.x primary event
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                itemCount: cart.item_count,
                source: 'aecdxc-add-all-to-cart'
              }
            }
          })
        );

        // Fallback for some Horizon builds
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );

        return cart;
      })
      .catch(function () {
        // Silent fail on refresh -- cart was still modified
      });
  }

  /* ====================================
     ADD ALL TO CART
     ==================================== */

  addBtn.addEventListener('click', function () {
    addBtn.disabled = true;
    if (clearBtn) clearBtn.disabled = true;
    addBtn.textContent = 'Loading\u2026';
    setStatus('');

    var variantIds = getPageVariantIds();

    if (variantIds.length === 0) {
      setStatus('No products found on this page.', 'error');
      resetButtons();
      return;
    }

    // Fetch current cart to skip already-added items
    fetchJSON('/cart.js')
      .then(function (cart) {
        var inCart = {};
        cart.items.forEach(function (item) { inCart[item.variant_id] = true; });
        var toAdd = variantIds.filter(function (id) { return !inCart[id]; });

        if (toAdd.length === 0) {
          setStatus('All products on this page are already in your cart.');
          resetButtons();
          return;
        }

        addBtn.textContent = 'Adding ' + toAdd.length + ' item' + (toAdd.length !== 1 ? 's' : '') + '\u2026';

        return addItemsToCart(toAdd).then(function () {
          var capped = variantIds.length >= CAP;
          var msg = toAdd.length + ' item' + (toAdd.length !== 1 ? 's' : '') + ' added to cart.';
          if (capped) msg += ' Limited to first ' + CAP + ' products on the page.';
          setStatus(msg, 'success');
          return refreshHorizonCart();
        });
      })
      .catch(function (err) {
        setStatus('Something went wrong. Please try again.', 'error');
        console.error('[aecdxc-add-all-to-cart]', err);
      })
      .then(function () {
        resetButtons();
      });
  });

  /* ====================================
     CLEAR CART
     ==================================== */

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (!confirm('Are you sure you want to remove all items from your cart?')) return;

      addBtn.disabled = true;
      clearBtn.disabled = true;
      clearBtn.textContent = 'Clearing\u2026';
      setStatus('');

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Clear failed: ' + res.status);
          setStatus('Your cart has been cleared.', 'success');
          return refreshHorizonCart();
        })
        .catch(function (err) {
          setStatus('Could not clear cart. Please try again.', 'error');
          console.error('[aecdxc-clear-cart]', err);
        })
        .then(function () {
          resetButtons();
        });
    });
  }

  /* ====================================
     HELPERS
     ==================================== */

  function isListViewActive() {
    var listView = document.getElementById('aecdxc-list-view');
    return listView && listView.style.display !== 'none' && listView.offsetParent !== null;
  }

  function getPageVariantIds() {
    var ids = [];

    if (isListViewActive()) {
      // List view: read variant IDs from all table row checkboxes (not just checked ones)
      var rows = document.querySelectorAll('#aecdxc-list-view .aecdxc-row-check[data-variant-id]');
      for (var i = 0; i < rows.length; i++) {
        var id = parseInt(rows[i].getAttribute('data-variant-id'), 10);
        if (!id || isNaN(id)) continue;
        if (ids.indexOf(id) === -1) ids.push(id);
        if (ids.length >= CAP) break;
      }
    } else {
      // Grid view: read variant IDs from product card add-to-cart forms
      var inputs = document.querySelectorAll(
        'form[action="/cart/add"] input[name="id"], form[action*="/cart/add"] input[name="id"]'
      );
      for (var j = 0; j < inputs.length; j++) {
        var fid = parseInt(inputs[j].value, 10);
        if (!fid || isNaN(fid)) continue;
        if (ids.indexOf(fid) === -1) ids.push(fid);
        if (ids.length >= CAP) break;
      }
    }

    return ids;
  }

  function addItemsToCart(variantIds) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: variantIds.map(function (id) { return { id: id, quantity: 1 }; })
      }),
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (err) {
          throw new Error(err.description || 'Cart add failed.');
        });
      }
      return res.json();
    });
  }

  function fetchJSON(url) {
    return fetch(url).then(function (res) {
      if (!res.ok) throw new Error('Fetch failed: ' + url + ' (' + res.status + ')');
      return res.json();
    });
  }

  function setStatus(msg, type) {
    statusEl.textContent = msg;
    statusEl.className = 'aecdxc-add-all-status' + (type ? ' aecdxc-add-all-status--' + type : '');
  }

  function resetButtons() {
    addBtn.disabled = false;
    addBtn.textContent = 'Add All to Cart';
    if (clearBtn) {
      clearBtn.disabled = false;
      clearBtn.textContent = 'Clear Cart';
    }
  }
})();